import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'std-paginator',
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.scss'],
    standalone: false
})
export class PaginatorComponent {
  @Input() current: number = 1; // numero corrente della pagina
  @Input() total: number = 1; // numero totale di pagine
  @Input() arrowLeft = ''; // classi custom della freccia sinistra
  @Input() arrowRight = ''; // classi custom della freccia destra
  @Input() customBox = ''; // classi custom per il box del paginator
  @Input() customBoxSelected = ''; // classi custom per il box del paginator selezionato
  @Output() pageChange = new EventEmitter<number>(); //come evento manda la pagina selezionata

  constructor() {}

  changePage(newPage: number) {
    this.pageChange.emit(newPage);
  }

  nextPage() {
    const newPage = this.current < this.total ? this.current + 1 : this.total;
    this.changePage(newPage);
  }

  prevPage() {
    const newPage = this.current > 1 ? this.current - 1 : 1;
    this.changePage(newPage);
  }
}
